import React from "react";
import { AppBar, Container, Toolbar, Typography } from "@mui/material";

const Footer = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        top: "auto",
        bottom: 0,
        backgroundColor: "white",
        boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ justifyContent: "center" }}>
          <Typography variant="body1" className="footer_text">
            Copyright © Zuno General Insurance Limited
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Footer;
